import './polyfills/element_matches.js';
import {createState} from './state.js';
import {createStore} from './store.js';
import {createViewControl} from './viewcontrol.js';
import {arrayFlat} from './utils/array.js';
import './components/ekmsearchcategories.js';
import {getState as getHistoryState} from './utils/history.js';
import {tryCatch} from './utils/trycatch.js';

function getSearchForms(){
	return Array.from(document.forms).filter(function(form){
		return /[?&]function=search(&|$)/.test(form.action);
	});
}

function getSearchInputs(form){
	return Array.from(form.elements).filter(function(el){
		return el.name === 'search';
	});
}

function getAllSearchInputs(){
	return arrayFlat(getSearchForms().map(getSearchInputs));
}

function getFrameState(){
	const {caught, value: href} = tryCatch(() => window.parent.location.href);

	if (caught) return {};

	const url = new URL(href);

	if (url.pathname === '/ekmps/shops/shop.asp'){
		if (url.origin.match(/^https:\/\/youraccount\.\d+\.ekm\.net/)){
			return {
				showEditButtons: true
			};
		}
	}

	return {};
}

function getConfig(){
	var script = Array.from(document.scripts).find(function(script){
		return script.getAttribute('data-config') === 'search';
	});
	if (script) return {
		...JSON.parse(script.text),
		...getHistoryState(),
		...getFrameState(),
	};
	return {};
}

function go(){
	var config = getConfig();

	if (config.disabled) return;

	var inputs = getAllSearchInputs();
	var state = createState({
		user: config.user,
		isSearchPage: config.isSearchPage,
		searchQuery: config.searchQuery,
		searchCategories: config.searchCategories,
		token: config.token,
		showEditButtons: config.showEditButtons,
		showAttributeFilter: config.showAttributeFilter,
		showCategoryFilter: config.showCategoryFilter,
		showTDPrices: config.showTDPrices,
		isTDUser: config.isTDUser,
		topLevelCategories: config.topLevelCategories,
		showPriceFilter: config.showPriceFilter,
		attributes: config.attributes,
		attributeNames: config.attributeNames,
		priceRange: config.priceRange,
		inputs: inputs,
		currency: config.currency
	});
	var store = createStore(state);
	var viewController = createViewControl(store);
	store.dispatch({
		type: 'INIT'
	});

	window.addEventListener('popstate', event => {
		store.dispatch({
			type: 'HISTORY_POP_STATE',
			state: event.state
		});
	});
}

window.addEventListener('DOMContentLoaded', function onDOMContentLoaded(){
	window.removeEventListener('DOMContentLoaded', onDOMContentLoaded);
	go();
});